export default __webpack_public_path__ + "static/media/1176.c850312c.png";